import React, { useEffect } from 'react'
import ReactDOM from 'react-dom'

export default function IframeModal({ src, onClose, downloadName }) {
  // Kan lukkes med ESC
  useEffect(() => {
    const onKey = e => e.key === 'Escape' && onClose()
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [onClose])

  return ReactDOM.createPortal(
    <div
      onClick={onClose}
      style={{
        position:   'fixed',
        top: 0, left: 0, right: 0, bottom: 0,
        background: 'rgba(0,0,0,0.6)',
        display:    'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex:     10000,
      }}
    >
    <div
        onClick={e => e.stopPropagation()}
        style={{
            position:   'relative',
            width:      '80vw',
            height:     '90vh',
            background: '#fff',
            borderRadius: 8,
            overflow:   'hidden',
        }}
    >
    <button
        onClick={onClose}
        style={{
            position: 'absolute',
            top:      8,
            right:    8,
            background: 'transparent',
            border:   'none',
            fontSize:  '1.5rem',
            cursor:    'pointer',
            zIndex:    1,
        }}
    >
        ✕
    </button>

    <iframe
        src={src}
        title="PDF Preview"
        style={{
        width:  '100%',
        height: '100%',
        border: 'none',
        }}
    />
    </div>
    </div>,
    document.body
  )
}